import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";
import { Badge } from "@/components/ui/badge";
import { Link } from "wouter";
import { Skeleton } from "@/components/ui/skeleton";

export function BlogCategories() {
  const { data, isLoading } = useQuery({
    queryKey: ['/api/blog/categories'],
    queryFn: getQueryFn({ on401: "throw" })
  });
  
  const categories = data?.categories || [];
  
  if (isLoading) {
    return (
      <div className="space-y-3">
        <h3 className="text-lg font-semibold mb-3">Categories</h3>
        <div className="space-y-2">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-6 w-16" />
          <Skeleton className="h-6 w-28" />
        </div>
      </div>
    );
  }
  
  // If no categories are returned yet, show default ones
  const displayCategories = categories.length > 0 ? categories : [
    'Data Analytics', 
    'Data Engineering', 
    'CDP', 
    'AI'
  ];
  
  return (
    <div>
      <h3 className="text-lg font-semibold mb-3">Categories</h3>
      <div className="flex flex-wrap gap-2">
        {displayCategories.map((category) => (
          <Link key={category} href={`/blog?category=${encodeURIComponent(category)}`}>
            <Badge 
              variant="secondary" 
              className="cursor-pointer hover:bg-primary/20"
            >
              {category}
            </Badge>
          </Link>
        ))}
      </div>
    </div>
  );
}